import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAllCompanies } from "../api/utility/companyAPI";
import { useSelector } from "react-redux";
import { SET_COMPANY, SET_FINANCIAL_YEAR } from "../redux/actionTypes";
import { useDispatch } from "react-redux";
import { showToast } from "../components/ToastifyNotification";
import { GetAllFinancialYears } from "../api/utility/financialYearAPI";

const CompanySelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const isAuthenticated = useSelector(state => state?.authReducer?.isAuthenticated || false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`/login`);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const fetchCompanies = async () => {
      const res = await GetAllCompanies();
      if (res?.success) setCompanies(res.data);
    };
    fetchCompanies();
  }, []);

  const handleCompanySelect = async (company) => {
    try {
      setSelectedCompany(company);

      // 1️⃣ Dispatch company first (this will store in redux + localStorage)
      dispatch({ type: SET_COMPANY, payload: company });
    } catch (error) {
      showToast("error", "Failed to load financial year");
    }
  };

  const handleProceed = () => {
    if (!selectedCompany) {
      showToast("error", "Please select a company");
      return;
    }

    dispatch({ type: SET_COMPANY, payload: selectedCompany });

    navigate("/financial-year-selection");
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid p-0">
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  {/* Header */}
                  <div className="text-center">
                    HOSPITAL MANAGEMENT SOFTWARE
                  </div>

                  <div className="card mt-4">
                    <div className="card-body">
                      <div className="text-center">
                        <h4>SELECT COMPANY</h4>
                        <h6>Please choose your company to continue</h6>
                      </div>

                      <div className="theme-form mt-4">
                        <div className="form-group">
                          {companies.map(company =>
                            <div key={company._id} className="form-check mb-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="company"
                                id={`company-${company._id}`}
                                value={company._id}
                                onChange={() => handleCompanySelect(company)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`company-${company._id}`}
                              >
                                {company.name}
                              </label>
                            </div>
                          )}
                        </div>

                        <div className="form-group form-row mt-4 mb-0 d-grid">
                          <button
                            className="btn btn-primary"
                            onClick={handleProceed}
                            disabled={!selectedCompany}
                          >
                            OK / Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySelection;
